module.exports = __webpack_public_path__ + "img/vip-bonus.37414daa.png";